module.exports = __webpack_public_path__ + "static/gallery-12-d31900151ef2bd51019c456d39e71aea.jpg";